// Play's contentFolder prop is already a complete media URL, while some local
// callers may supply only the bare activity folder. Both existing contracts
// are supported without changing the host or global audio actions.
export function mathRodsFeedbackAudioUrl(value, {contentFolder='', versionType='', s3bucketPublicURL=''}={}) {
  if (typeof value !== 'string') return '';
  if (/^https?:\/\//i.test(value)) return value;
  if (!/^[A-Za-z0-9][A-Za-z0-9_.-]*\.(mp3|m4a|ogg|wav|webm)$/i.test(value) || !contentFolder) return '';
  const prefix=/^https?:\/\//i.test(contentFolder)
    ? contentFolder
    : `${s3bucketPublicURL.replace(/\/+$/,'')}/${contentFolder.replace(/^\/+|\/+$/g,'')}/${versionType?`languageVersionData/${versionType}`:'gamedata'}`;
  return `${prefix.replace(/\/+$/,'')}/${encodeURIComponent(value)}`;
}
